import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Login"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 22.5H10.5C9.67157 22.5 9 21.8284 9 21V18.75H10.5V21H19.5V3H10.5V5.25H9V3C9 2.17157 9.67157 1.5 10.5 1.5H19.5C20.3284 1.5 21 2.17157 21 3V21C21 21.8284 20.3284 22.5 19.5 22.5ZM10.9425 15.4425L13.6275 12.75H3V11.25H13.6275L10.9425 8.5575L12 7.5L16.5 12L12 16.5L10.9425 15.4425Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Login.vue"]]);
